import { z } from 'zod';
import { PhoneNumberCallMode } from './callMode.js';
import { PhoneNumberFunction } from './phoneNumberFunction.js';
import { PhoneNumberType } from './phoneNumberType.js';
import { PhoneNumberCapabilitySchema } from '../phoneNumberCapability/index.js';
/**
 * A phone number configuration as primary serves it, with its capabilities populated.
 * `organizationId` is null for configurations shared across organizations, and
 * `supportedFunctions` is derived from the capabilities rather than stored.
 */
export const PhoneNumberConfigurationSchema = z.object({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    phoneNumber: z.string(),
    displayName: z.string(),
    type: z.enum(PhoneNumberType),
    sipPracticeRoutingEnabled: z.boolean(),
    organizationId: z.uuid().nullable(),
    deletedTimestamp: z.iso.datetime().nullable(),
    sourceVendorAccountId: z.uuid().nullable(),
    callMode: z.enum(PhoneNumberCallMode),
    capabilities: z.array(PhoneNumberCapabilitySchema),
    supportedFunctions: z.array(z.enum(PhoneNumberFunction)),
});
/** Path params for `GET /flow/data-access/phone-number-configurations/:id`. */
export const PhoneNumberConfigurationFindOneParamsSchema = z
    .object({
    id: z.uuid(),
})
    .strict();
//# sourceMappingURL=phoneNumberConfiguration.js.map